// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2au-v","label":"SetPasswdForm_label__KY_ux"};